import { Joyride, STATUS, EVENTS, ACTIONS } from 'react-joyride';
import { useGuidedTour } from '@/context/GuidedTourContext';
import { TOURS } from '@/lib/guidedTours';

/** Mounts react-joyride whenever a tour is active. Kept minimal: our tour copy
 * already carries titles inline via the step.title prop. */
const GuidedTourRunner = () => {
  const { activeTourId, stopTour } = useGuidedTour();
  if (!activeTourId) return null;
  const tour = TOURS[activeTourId];
  if (!tour) return null;

  const joyrideSteps = tour.steps.map(s => ({
    target: s.target,
    content: (
      <div className="text-left">
        {s.title && <div className="font-semibold text-[#0A0A0A] mb-1">{s.title}</div>}
        <div className="text-[13px] text-[#4B5563] leading-relaxed">{s.content}</div>
      </div>
    ),
    placement: s.placement || 'auto',
    disableBeacon: !!s.disableBeacon,
  }));

  const onCallback = (data) => {
    const { status, type, action } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      stopTour();
    } else if (type === EVENTS.TOUR_END || action === ACTIONS.CLOSE) {
      stopTour();
    }
  };

  return (
    <Joyride
      key={activeTourId}
      steps={joyrideSteps}
      run
      continuous
      showSkipButton
      showProgress
      disableBeacon
      disableOverlayClose
      scrollToFirstStep
      disableScrolling={false}
      spotlightClicks={false}
      callback={onCallback}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Done',
        next: 'Next',
        skip: 'Skip tour',
      }}
      styles={{
        options: {
          primaryColor: '#002FA7',
          zIndex: 10000,
          arrowColor: '#ffffff',
          backgroundColor: '#ffffff',
          textColor: '#0A0A0A',
        },
        tooltip: {
          borderRadius: 10,
          padding: 16,
          fontSize: 13,
          maxWidth: 360,
        },
        tooltipContent: { padding: 0 },
        buttonNext: {
          backgroundColor: '#002FA7',
          borderRadius: 6,
          fontSize: 12,
          padding: '8px 14px',
        },
        buttonBack: {
          color: '#4B5563',
          fontSize: 12,
          marginRight: 8,
        },
        buttonSkip: {
          color: '#9CA3AF',
          fontSize: 11,
        },
      }}
    />
  );
};

export default GuidedTourRunner;
